import { defineStore } from 'pinia'

export const usePreferredDateStore = defineStore('preferredDateStore', {
  state: () => ({
    preferredDate: null
  })
})
